<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-model="openModel"
    classes="modal-container"
    :content-class="`modal-content ${contentClass}`"
    focus-trap
  >
    <span class="modal__title">
      <slot name="title"></slot>
    </span>
    <div class="modal__content">
      <slot :params="params"></slot>
    </div>
    <span class="modal__close" @click="close">
      <img class="modal__close-normal" src="image/btn_modal_close.webp" />
      <img class="modal__close-guarantee" src="image/icon_close.svg" />
    </span>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal';

export default {
  name: 'AppDialog',
  components: {
    VueFinalModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  .modal__content>div{
    box-shadow: none;
  }
  @media screen and (max-width: 579px) {
    &.guaranteeModal{
    max-height: 100%;
    min-height: 100%;
    margin: 0;
    overflow: auto;
    .modal__close{
      position: fixed;
      top:10px;
      right: 10px;
      opacity: .5;
      &-normal{
        display: none;
      }
      &-guarantee{
        display: block;
      }
    }
    }
  }
}
.modal__content {
  flex-grow: 1;
  //overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: -15px;
  right: -15px;
  cursor: pointer;
  &-normal{
    display: block;
    width: 30px;
  height: 30px;
  }
  &-guarantee{
  display: none;
    width: 17px;
  }
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
